<template>
  <v-container fluid>
    <DashboardAdmin v-if="isAdmin" />
    <DashboardClient v-if="isClient"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardAdmin from './../components/DashboardAdmin/DashboardAdmin.vue';
import DashboardClient from './../components/DashboardClient/DashboardClient.vue';

export default {
  name: 'dashboard',
  computed: {
    ...mapGetters('user', [
      'role',
    ]),
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    isClient() {
      return this.role === 'client';
    },
  },
  components: {
    DashboardAdmin,
    DashboardClient,
  },
};
</script>
